/* Publish by EComposer at 2024-07-25 01:17:49*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-bjzzokl0vt"]=  window.__ectimmers["ecom-bjzzokl0vt"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-bjzzokl0vt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bjzzokl0vt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hn70ek5fnt9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hn70ek5fnt9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j8x1jozvy3i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j8x1jozvy3i', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6esxe850nw5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6esxe850nw5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8pvzm349zuw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8pvzm349zuw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fl6erwwxv3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fl6erwwxv3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kxwt9841fns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kxwt9841fns', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l43xbdm1vb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l43xbdm1vb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bsbh0aw7eu5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bsbh0aw7eu5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nq0l0e2vgas').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nq0l0e2vgas', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-167v0y9q5gf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-167v0y9q5gf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zny1g4f7es').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zny1g4f7es', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nukr8nj18f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nukr8nj18f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-yj93w535nh"]=  window.__ectimmers["ecom-yj93w535nh"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-yj93w535nh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yj93w535nh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zxkhufmr8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zxkhufmr8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oc6sn7rs9e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oc6sn7rs9e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pgz74jm1ph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pgz74jm1ph', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7hy1la79gqw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7hy1la79gqw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-st6q2mecp8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-st6q2mecp8h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rfoxrl850cd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rfoxrl850cd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oxiz6xccm9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oxiz6xccm9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o2qpngc3meq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o2qpngc3meq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2bbekts1cdg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2bbekts1cdg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vuay39y76d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vuay39y76d', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mbccxnhdk7"]=  window.__ectimmers["ecom-mbccxnhdk7"] || {};
if(!this.settings||!this.$el)return;var e=this.$el.querySelector(".ecom-video_overlay-icon");e&&e.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"){let n=this.$el.querySelector(".ecom_video");n.autoplay=!0,n.load(),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}else{let n=this.$el.querySelector(".ecom_iframe"),s=n.getAttribute("src");s.includes("autoplay=0")?s=s.replace("autoplay=0","autoplay=1"):s=s+"&autoplay=1",n.setAttribute("src",s),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}}),this.$el.querySelectorAll("[data-ec-tracking-id]").forEach(function(n){n.dataset.ecTrackingId&&n.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:n.id,tracking_id:n.dataset.ecTrackingId})},{once:!0})});const i=this.$el.querySelector("[ecom-modal]");if(i&&this.settings.image_overlay&&this.settings.play_on_lightbox&&window.EComModal){var t=this.id;new window.EComModal(i,{cssClass:[t,"ecom-core","ecom-core-simulator"],onOpen:function(){var n=document.querySelector(".ecom-modal."+t);n&&n.querySelector(".ecom-modal-box__content").classList.add("ecom-element_video-iframe")}})}

                    });
                    
                        document.querySelectorAll('.ecom-mbccxnhdk7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mbccxnhdk7', settings: {"source":"vimeo","image_overlay":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}